import {
    GET_TRANSACTION_HISTORY_REQUEST,
    GET_TRANSACTION_HISTORY_SUCCESS,
    GET_TRANSACTION_HISTORY_FAILURE,
    RESET_TRANSACTION_HISTORY
} from "../ActionTypes/ActionTypes";

const initialState = {
    loading: false,
    error: null,

    list: [],
    pagination: {
        page: 1,
        limit: 10,
        total: 0,
        totalPages: 0
    },

    totals: {
        creditINR: 0,
        debitINR: 0,
        netPNL: 0
    },

    lastQuery: null,
    isFirstLoad: true
};

export default function transactionReducer(state = initialState, action) {
    switch (action.type) {
        case GET_TRANSACTION_HISTORY_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case GET_TRANSACTION_HISTORY_SUCCESS:
            return {
                ...state,
                loading: false,
                list: action.payload.list,
                pagination: action.payload.pagination,
                totals: action.payload.totals,
                lastQuery: action.payload.query,
                isFirstLoad: false
            };

        case GET_TRANSACTION_HISTORY_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
                isFirstLoad: false
            };

        case RESET_TRANSACTION_HISTORY:
            return initialState;

        default:
            return state;
    }
}